/** SMS connector display name used to resolve the authenticated workspace connector. */
export const SMS_CONNECTOR_NAME = 'Sms';

/** Connector flow names (must match workspace connector flow configuration for the SMS connector). */
export const SMS_CONNECTOR_FLOW_NAME = 'Send';
export const SMS_TEMPLATE_LIST_FLOW_NAME = 'Template List';
export const SMS_TEMPLATE_INSERT_FLOW_NAME = 'Insert Template';
export const SMS_TEMPLATE_EDIT_FLOW_NAME = 'Edit Template';
export const SMS_TEMPLATE_DELETE_FLOW_NAME = 'Delete Template';
export const SMS_ALIAS_LIST_FLOW_NAME = 'Alias List';

/**
 * Names of the flow serving each role on the SMS connector.
 * Lookups are always scoped to the authenticated Sms connector id — never by name alone.
 */
export const SMS_FLOW_NAMES = {
  send: [SMS_CONNECTOR_FLOW_NAME],
  templateList: [SMS_TEMPLATE_LIST_FLOW_NAME],
  templateInsert: [SMS_TEMPLATE_INSERT_FLOW_NAME],
  templateEdit: [SMS_TEMPLATE_EDIT_FLOW_NAME],
  templateDelete: [SMS_TEMPLATE_DELETE_FLOW_NAME],
  aliasList: [SMS_ALIAS_LIST_FLOW_NAME],
} as const;

export type SmsFlowRole = keyof typeof SMS_FLOW_NAMES;
